<template>
  <div class="container py-4">
    <h3 class="mb-4">SMS Credits</h3>

    <div class="card p-4 shadow-sm">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5>Available SMS Balance</h5>
          <h2 class="text-success">{{ smsBalance.toLocaleString() }}</h2>
          <p class="text-muted">1 SMS Credit = Ksh {{ ratePerSms }}</p>
        </div>
        <button class="btn btn-primary btn-lg" @click="showTopUpModal = true">
          Top Up Credits
        </button>
      </div>
    </div>

    <!-- Info -->
    <div class="alert alert-info mt-4">
      <strong>Note:</strong> Your SMS balance will be automatically updated once
      your payment is confirmed.
    </div>

    <!-- Modal -->
    <div
      v-if="showTopUpModal"
      class="modal fade show"
      style="display: block; background: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content p-3">
          <div class="modal-header">
            <h5 class="modal-title">Top Up SMS Credits</h5>
            <button
              type="button"
              class="btn-close"
              @click="showTopUpModal = false"
            ></button>
          </div>
          <div class="modal-body">
            <p class="fw-bold mb-2">Pay via M-Pesa Paybill:</p>
            <ul class="list-group mb-3">
              <li
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>Paybill Number:</span>
                <strong>522522</strong>
              </li>
              <li
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>Account Number:</span>
                <strong>1313480363</strong>
              </li>
            </ul>

            <p>
              Enter the amount you wish to pay. Your SMS credits will be updated
              automatically once payment is confirmed.
            </p>

            <div class="mt-3">
              <label class="form-label">Amount (Ksh)</label>
              <input
                type="number"
                class="form-control"
                v-model="topUpAmount"
                min="1"
                placeholder="e.g., 500"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="showTopUpModal = false">
              Cancel
            </button>
            <button class="btn btn-success" @click="confirmTopUp">
              I Have Paid
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal backdrop -->
    <div v-if="showTopUpModal" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
import { generalApiRequest } from "../api/apiIndex";

export default {
  name: "SmsBalance",
  data() {
    return {
      smsBalance: 0,
      ratePerSms: 0.7,
      showTopUpModal: false,
      topUpAmount: "",
    };
  },
  methods: {
    confirmTopUp() {
      if (!this.topUpAmount) {
        alert("Please enter an amount before confirming.");
        return;
      }
      alert(
        `Thank you! We've received your Query. Your credits will update automatically once confirmed.`
      );
      this.showTopUpModal = false;
    },
    async get_credit_balance() {
      const url = "get_available_credit";
      const body = {};
      const response = await generalApiRequest(url, "GET", body, 1);
      this.smsBalance = response.available_credit;
    },
  },
  mounted() {
    // this.fetchSmsBalance();
    this.get_credit_balance();
  },
};
</script>

<style scoped>
.card {
  border-radius: 12px;
}
.btn {
  border-radius: 8px;
}
.modal-content {
  border-radius: 10px;
}
</style>
